// import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Text, Divider, Flex, Avatar, Box, Badge, Table, Thead, Tbody, Tr, Th, Td, TableContainer, ModalCloseButton, useDisclosure, Button, ModalFooter, Tooltip, VStack, Tabs, TabList, Tab, InputGroup, InputLeftElement, Input, Checkbox } from "@chakra-ui/react";
// import { IconButton } from "@chakra-ui/react";
// import { DeleteIcon, SearchIcon } from "@chakra-ui/icons";
// import { useFetch } from "../../../../../../hooks/useFetch";
// import { useState } from "react";
// import { AlertCard, CustomToast } from "../../../../../../components";
// import { MultiSelectMenu } from "../../../../../../components/MultiSelectMenu/MultiSelectMenu";
// import { showDateTime } from "../../../../../../utilities/helper";
// interface Participant {
//     id: number;
//     name: string;
//     role: string;
//     tl_Name: string;
//     manager_Name: string;
//     company_Name: string;
//     branch_Name: string;
//     department_Name: string;
//     avatarUrl?: string;
//     attendance_Status?: string;
//     join_Status?: string;
//     joined_At?: string;
//     declined_At?: string;
//     acceptance_Status?: string;
//     decline_Reason?: string;
//     is_Creator: boolean;
//     displayName: string
// }

// interface ParticipantsModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     participants: Participant[];
//     hasPermission: any,
//     selectedMeetingId: number,
//     reloadParticipants: (meetingId: number, status: string) => void;
//     meetingStatus: string
// }

// const ParticipantsModal = ({ isOpen, onClose, participants, hasPermission, selectedMeetingId, reloadParticipants, meetingStatus }: ParticipantsModalProps) => {
//     const addModal = useDisclosure();
//     const [employeeOptions, setEmployeeOptions] = useState<any[]>([]);
//     const [selectedEmployees, setSelectedEmployees] = useState<number[]>([]);
//     const [addLoading, setAddLoading] = useState(false);
//     const [participantTab, setParticipantTab] = useState<"Employee" | "Team" | "Mixed">("Employee");
//     const [search, setSearch] = useState("");


//     const [removeConfirm, setRemoveConfirm] = useState<{
//         participantId: number | null;
//         isOpen: boolean;
//     }>({
//         participantId: null,
//         isOpen: false
//     });

//     const { addToast } = CustomToast();
//     const { fetchApi } = useFetch(addToast);


//     // const loadCompanies = async () => {
//     //     const response = await fetchApi("Dropdown/company", "GET");
//     //     if (response) setCompanyOptions(response);
//     // };

//     // const loadBranches = async (companyIds: number[]) => {
//     //     if (!companyIds.length) return;

//     //     const query = companyIds.map(id => `companyIds=${id}`).join("&");
//     //     const response = await fetchApi(`Dropdown/MultiBranchDropDown?${query}`, "GET");

//     //     if (response) setBranchOptions(response);
//     // };

//     const loadEmployeesForAdd = async (companyIds: number[], branchIds: number[]) => {
//         if (!companyIds.length || !branchIds.length) {
//             setEmployeeOptions([]);
//             return;
//         }

//         const params = new URLSearchParams();
//         params.append("participantType", "Employee");
//         companyIds.forEach(id => params.append("companyIds", id.toString()));
//         branchIds.forEach(id => params.append("branchIds", id.toString()));

//         const response = await fetchApi(`Meetings/participantList?${params.toString()}`, "GET");
//         if (response) {
//             const filtered = response.filter((emp: any) => !participants.some(p => p.id === emp.id));
//             setEmployeeOptions(filtered);
//         }
//     };


//     const confirmRemoveParticipant = async () => {
//         if (!removeConfirm.participantId) return;
//         const response = await fetchApi("Meetings/remove-participant", "PUT", { meeting_Id: selectedMeetingId, participant_Id: removeConfirm.participantId });
//         if (response) {
//             addToast({ message: "Participant removed successfully", status: "success" });
//             reloadParticipants(selectedMeetingId, meetingStatus);
//         }
//         setRemoveConfirm({ participantId: null, isOpen: false });
//     };



//     const handleAddParticipants = async () => {
//         // if (!selectedCompanies.length) {
//         //     addToast({ message: "Please select at least one company", status: "error" });
//         //     return;
//         // }
//         // if (!selectedBranches.length) {
//         //     addToast({ message: "Please select at least one branch", status: "error" });
//         //     return;
//         // }

//         if (!selectedEmployees.length) {
//             addToast({ message: "Please select at least one employee", status: "error" });
//             return;
//         }

//         setAddLoading(true);
//         try {
//             const response = await fetchApi("Meetings/update-participants", "POST", {
//                 meeting_Id: selectedMeetingId,
//                 // companyIds: selectedCompanies,
//                 // branchIds: selectedBranches,
//                 selectedParticipants: selectedEmployees
//             });
//             if (response) {
//                 addToast({ message: "Participants added successfully", status: "success" });
//                 // setSelectedCompanies([]);
//                 // setSelectedBranches([]);
//                 setSelectedEmployees([]);
//                 // setBranchOptions([]);
//                 // setEmployeeOptions([]);
//                 reloadParticipants(selectedMeetingId, meetingStatus);
//                 addModal.onClose();
//             }
//         } finally {
//             setAddLoading(false);
//         }
//     };


//     const ParticipantRow = ({ item, checked, onToggle, }: { item: Participant; checked: boolean; onToggle: () => void }) => (
//         <Flex align="center" gap={3} px={3} py="9px" borderBottom="0.5px solid" borderColor="gray.100" bg={checked ? "green.50" : "white"} cursor="pointer" onClick={onToggle} transition="background 0.1s" _hover={{ bg: checked ? "green.50" : "gray.50" }} _last={{ borderBottom: "none" }} >
//             <Avatar size="sm" name={item.displayName} bg="blue.100" color="blue.700" />
//             <Box flex={1}>
//                 <Text fontSize="sm" fontWeight="500" color="gray.800">{item.displayName}</Text>
//                 <Text fontSize="xs" color="gray.400">{item.role}</Text>
//             </Box>
//             <Checkbox isChecked={checked} onChange={onToggle} colorScheme="green" onClick={(e) => e.stopPropagation()} />
//         </Flex>
//     );


//     const SkeletonRows = () => (
//         <VStack spacing={0} align="stretch">
//             {[...Array(5)].map((_, i) => (
//                 <Flex key={i} align="center" gap={3} px={3} py="9px" borderBottom="0.5px solid" borderColor="gray.100">
//                     <Box w="32px" h="32px" borderRadius="full" bg="gray.100" />
//                     <Box flex={1}>
//                         <Box h="11px" bg="gray.100" borderRadius="md" w="55%" mb={1} />
//                         <Box h="9px" bg="gray.50" borderRadius="md" w="35%" />
//                     </Box>
//                     <Box w="14px" h="14px" borderRadius="3px" bg="gray.100" />
//                 </Flex>
//             ))}
//         </VStack>
//     );


//     return (
//         <>
//             <Modal isOpen={isOpen} onClose={() => { setSelectedEmployees([]); setEmployeeOptions([]); onClose(); }} size="5xl" isCentered>
//                 <ModalOverlay />
//                 <ModalContent h="70vh">
//                     <ModalHeader>
//                         <Flex direction="column" align="center" gap={2}>
//                             <Text className="font-poppins text_semibold text_xl" textAlign="center">Meeting Participants</Text>
//                             <Flex gap={3} wrap="wrap" justify="center">
//                                 <Text className="font-poppins text_md text_medium" color="gray.500">Total Participants: {participants.length}</Text>
//                             </Flex>
//                         </Flex>
//                         {hasPermission("MeetingsManagement", "Add_Participant") && meetingStatus !== "Completed" && (<Button size="sm" colorScheme="green" onClick={() => { loadCompanies(); addModal.onOpen(); }}>Add Participant</Button>)}
//                     </ModalHeader>
//                     <ModalCloseButton />
//                     <Divider />

//                     <ModalBody overflowY="auto" p={4}>
//                         <TableContainer>
//                             <Table size="sm">
//                                 <Thead>
//                                     <Tr>
//                                         <Th className="font-poppins text_md text_medium">Participant</Th>
//                                         <Th className="font-poppins text_md text_medium">Tl</Th>
//                                         <Th className="font-poppins text_md text_medium">Manager</Th>
//                                         <Th className="font-poppins text_md text_medium">Company</Th>
//                                         <Th className="font-poppins text_md text_medium">Branch</Th>
//                                         <Th className="font-poppins text_md text_medium">Department</Th>
//                                         <Th className="font-poppins text_md text_medium">Acceptance</Th>
//                                         <Th className="font-poppins text_md text_medium">Status</Th>
//                                         <Th className="font-poppins text_md text_medium">Time</Th>
//                                         {hasPermission("MeetingsManagement", "Remove_Participant") && meetingStatus !== "Completed" && (<Th className="font-poppins text_md text_medium">Action</Th>)}
//                                     </Tr>
//                                 </Thead>

//                                 <Tbody>
//                                     {participants.map(p => (
//                                         <Tr key={p.id}>
//                                             <Td>
//                                                 <Flex align="center" gap={3}>
//                                                     <Avatar size="sm" name={p.name} src={p.avatarUrl || undefined} />
//                                                     <Box>
//                                                         <Text className="font-poppins text_md text_medium font_dark">{p.name}</Text>
//                                                         <Text className="font-poppins text_sm text_medium" color="gray.600">{p.role}</Text>
//                                                     </Box>
//                                                 </Flex>
//                                             </Td>
//                                             <Td><Badge className="font-poppins text_sm text_medium">{p.tl_Name}</Badge></Td>
//                                             <Td><Badge className="font-poppins text_sm text_medium">{p.manager_Name}</Badge></Td>
//                                             <Td><Badge className="font-poppins text_sm text_medium">{p.company_Name}</Badge></Td>
//                                             <Td><Badge className="font-poppins text_sm text_medium">{p.branch_Name}</Badge></Td>
//                                             <Td><Badge className="font-poppins text_sm text_medium">{p.department_Name}</Badge></Td>
//                                             <Td>
//                                                 {p.acceptance_Status === "Accepted" && (
//                                                     <Badge colorScheme="green">Accepted</Badge>
//                                                 )}
//                                                 {p.acceptance_Status === "Declined" && (
//                                                     <Tooltip label={p.decline_Reason || "No reason provided"} hasArrow placement="top" bg="gray.700" color="white" fontSize="sm" borderRadius="md" >
//                                                         <Badge colorScheme="red" cursor="pointer">Declined</Badge>
//                                                     </Tooltip>
//                                                 )}
//                                                 {(!p.acceptance_Status || p.acceptance_Status === "Pending") && (
//                                                     <Badge colorScheme={meetingStatus === "Completed" ? "red" : "grey.600"}>{meetingStatus === "Completed" ? "No Action Taken" : "Pending"}</Badge>
//                                                 )}
//                                             </Td>
//                                             <Td>
//                                                 {meetingStatus === "Completed" &&
//                                                     (!p.acceptance_Status || p.acceptance_Status === "Pending") ? (
//                                                     <Badge colorScheme="red">
//                                                         No Action Taken
//                                                     </Badge>
//                                                 ) : (
//                                                     <Badge
//                                                         colorScheme={
//                                                             p.attendance_Status === "Joined"
//                                                                 ? "green"
//                                                                 : p.attendance_Status === "Declined"
//                                                                     ? "red"
//                                                                     : p.attendance_Status === "Absent"
//                                                                         ? "orange"
//                                                                         : "gray"
//                                                         }
//                                                     >
//                                                         {p.attendance_Status ?? "Pending"}
//                                                     </Badge>
//                                                 )}
//                                             </Td>

//                                             <Td>
//                                                 {p.joined_At && (<Text className="font-poppins text_sm text_medium" color="green.600">{showDateTime(p.joined_At)}</Text>)}
//                                                 {p.declined_At && (<Text className="font-poppins text_sm text_medium" color="red.500">{showDateTime(p.declined_At)}</Text>)}
//                                                 {!p.joined_At && !p.declined_At && (<Text className="font-poppins text_sm text_medium" color="gray.500">—</Text>)}
//                                             </Td>
//                                             {hasPermission("MeetingsManagement", "Remove_Participant") && meetingStatus !== "Completed" && !p.is_Creator && (<Td> <IconButton aria-label="Remove Participant" icon={<DeleteIcon />} size="sm" colorScheme="red" variant="ghost" onClick={() => setRemoveConfirm({ participantId: p.id, isOpen: true })} /></Td>)}
//                                         </Tr>
//                                     ))}
//                                 </Tbody>
//                             </Table>
//                         </TableContainer>
//                     </ModalBody>
//                 </ModalContent>
//             </Modal>
//             <Modal isOpen={addModal.isOpen} onClose={addModal.onClose} size="lg" isCentered>
//                 <ModalOverlay />
//                 <ModalContent>
//                     <ModalHeader>Add Participants</ModalHeader>
//                     <ModalCloseButton />
//                     <ModalBody>
//                         {/* <MultiSelectMenu label="Company" options={companyOptions} selectedValues={selectedCompanies} setSelectedValues={(values) => { setSelectedCompanies(values); loadBranches(values); }} labelKey="company_Name" valueKey="company_ID" />
//                         <MultiSelectMenu label="Branch" options={branchOptions} selectedValues={selectedBranches} setSelectedValues={(values) => { setSelectedBranches(values); loadEmployeesForAdd(selectedCompanies, values); }} labelKey="branchName" valueKey="branchId" /> */}
//                         <MultiSelectMenu label="Employees" options={employeeOptions} selectedValues={selectedEmployees} setSelectedValues={setSelectedEmployees} labelKey="name" valueKey="id" />


//                         <VStack spacing={3} align="stretch">
//                             {/* Tab bar */}
//                             <Tabs index={["Employee", "Team", "Mixed"].indexOf(participantTab)} onChange={(i) => {
//                                 const types = ["Employee", "Team", "Mixed"] as const;
//                                 setParticipantTab(types[i]);
//                                 setSearch("");
//                             }}
//                                 colorScheme="green"
//                                 size="sm"
//                                 variant="line"
//                             >
//                                 <TabList>
//                                     <Tab fontWeight="500" fontSize="sm">Employee</Tab>
//                                     <Tab fontWeight="500" fontSize="sm">Team Lead</Tab>
//                                     <Tab fontWeight="500" fontSize="sm">Mixed</Tab>
//                                 </TabList>
//                             </Tabs>

//                             <InputGroup size="sm">
//                                 <InputLeftElement pointerEvents="none">
//                                     <SearchIcon color="gray.400" />
//                                 </InputLeftElement>
//                                 <Input placeholder="Search by name..." value={search} onChange={(e) => setSearch(e.target.value)} borderRadius="md" />
//                             </InputGroup>

//                             <Flex align="center" justify="space-between">
//                                 <Text fontSize="xs" color="gray.500">
//                                     {selectedParticipants.length > 0 ? `${selectedParticipants.length} selected` : "No participants selected yet"}
//                                 </Text>
//                                 <Checkbox isChecked={isAllSelected} onChange={(e) => handleSelectAll(e.target.checked)} colorScheme="green" size="sm" >
//                                     <Text fontSize="xs" color="gray.500">Select all</Text>
//                                 </Checkbox>
//                             </Flex>

//                             <Box border="0.5px solid" borderColor="gray.200" borderRadius="lg" overflow="hidden" maxH="320px" overflowY="auto">
//                                 {participantsLoading ? (
//                                     <SkeletonRows />
//                                 ) : listData.length === 0 ? (
//                                     <Flex align="center" justify="center" py={8}>
//                                         <Text fontSize="sm" color="gray.400">No results found</Text>
//                                     </Flex>
//                                 ) : (
//                                     listData.map((item, idx) => (
//                                         <ParticipantRow key={`${item.id}-${item.role}-${idx}`} item={item} checked={isSelected(item)} onToggle={() => toggleSelect(item)} />
//                                     ))
//                                 )}
//                             </Box>
//                         </VStack>


//                     </ModalBody>
//                     <ModalFooter>
//                         <Button colorScheme="green" isLoading={addLoading} onClick={handleAddParticipants} >Add </Button>
//                     </ModalFooter>
//                 </ModalContent>
//             </Modal>

//             <AlertCard isOpen={removeConfirm.isOpen} onClose={() => setRemoveConfirm({ participantId: null, isOpen: false })}
//                 onConfirm={confirmRemoveParticipant}
//                 description="Are you sure you want to remove this participant from the meeting?"
//                 colorScheme="red"
//             />
//         </>
//     );
// };

// export default ParticipantsModal;



import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Text, Divider,
    Flex, Avatar, Box, Badge, Table, Thead, Tbody, Tr, Th, Td, TableContainer,
    ModalCloseButton, useDisclosure, Button, ModalFooter, Tooltip, VStack,
    Tabs, TabList, Tab, InputGroup, InputLeftElement, Input, Checkbox,
    HStack, Spinner, Grid, GridItem,
} from "@chakra-ui/react";
import { IconButton } from "@chakra-ui/react";
import { DeleteIcon, SearchIcon, CheckIcon, ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { useFetch } from "../../../../../../hooks/useFetch";
import { useState, useCallback, useEffect, useMemo } from "react";
import { AlertCard, CustomToast } from "../../../../../../components";
import { showDateTime } from "../../../../../../utilities/helper";

// ─── Types ───────────────────────────────────────────────────────────────────

interface Participant {
    id: number;
    name: string;
    role: string;
    tl_Name: string;
    manager_Name: string;
    company_Name: string;
    branch_Name: string;
    department_Name: string;
    avatarUrl?: string;
    attendance_Status?: string;
    join_Status?: string;
    joined_At?: string;
    declined_At?: string;
    acceptance_Status?: string;
    decline_Reason?: string;
    is_Creator: boolean;
    displayName: string;
}

interface AvailabilityParticipant {
    id: number;
    name: string;
    role: string;
}

interface ParticipantsModalProps {
    isOpen: boolean;
    onClose: () => void;
    participants: Participant[];
    hasPermission: any;
    selectedMeetingId: number;
    reloadParticipants: (meetingId: number, status: string) => void;
    meetingStatus: string;
    /** Pass the meeting date/start/end so we can check availability */
    meetingDate?: string;
    meetingStartTime?: string;
    meetingEndTime?: string;
}

// ─── Step Indicator (2 steps) ────────────────────────────────────────────────

const AddStepIndicator = ({ step }: { step: 1 | 2 }) => {
    const steps = [{ label: "Select participants" }, { label: "Availability" }];
    return (
        <HStack justify="center" spacing={0} mt={3}>
            {steps.map((s, i) => {
                const num = i + 1;
                const isDone = num < step;
                const isActive = num === step;
                return (
                    <HStack key={num} spacing={0}>
                        <VStack spacing={1}>
                            <Flex
                                w="26px" h="26px" borderRadius="full" align="center" justify="center"
                                border="1.5px solid"
                                borderColor={isDone ? "green.500" : isActive ? "green.600" : "gray.300"}
                                bg={isActive ? "green.600" : isDone ? "green.50" : "white"}
                                color={isActive ? "white" : isDone ? "green.600" : "gray.400"}
                                fontSize="11px" fontWeight="600"
                            >
                                {isDone ? <CheckIcon boxSize="10px" /> : num}
                            </Flex>
                            <Text
                                fontSize="10px"
                                fontWeight={isActive ? "600" : "400"}
                                color={isActive ? "green.600" : isDone ? "green.500" : "gray.400"}
                                whiteSpace="nowrap"
                            >
                                {s.label}
                            </Text>
                        </VStack>
                        {i < 1 && (
                            <Box w="64px" h="1.5px" mb={4} mx={1} bg={isDone ? "green.400" : "gray.200"} />
                        )}
                    </HStack>
                );
            })}
        </HStack>
    );
};

// ─── Reusable sub-components ─────────────────────────────────────────────────

const ParticipantRow = ({
    item, checked, onToggle,
}: { item: { id: number; displayName: string; role: string }; checked: boolean; onToggle: () => void }) => (
    <Flex
        align="center" gap={3} px={3} py="9px"
        borderBottom="0.5px solid" borderColor="gray.100"
        bg={checked ? "green.50" : "white"}
        cursor="pointer" onClick={onToggle}
        transition="background 0.1s"
        _hover={{ bg: checked ? "green.50" : "gray.50" }}
        _last={{ borderBottom: "none" }}
    >
        <Avatar size="sm" name={item.displayName} bg="blue.100" color="blue.700" />
        <Box flex={1}>
            <Text fontSize="sm" fontWeight="500" color="gray.800">{item.displayName}</Text>
            <Text fontSize="xs" color="gray.400">{item.role}</Text>
        </Box>
        <Checkbox
            isChecked={checked} onChange={onToggle} colorScheme="green"
            onClick={(e) => e.stopPropagation()}
        />
    </Flex>
);

const SkeletonRows = () => (
    <VStack spacing={0} align="stretch">
        {[...Array(5)].map((_, i) => (
            <Flex key={i} align="center" gap={3} px={3} py="9px" borderBottom="0.5px solid" borderColor="gray.100">
                <Box w="32px" h="32px" borderRadius="full" bg="gray.100" />
                <Box flex={1}>
                    <Box h="11px" bg="gray.100" borderRadius="md" w="55%" mb={1} />
                    <Box h="9px" bg="gray.50" borderRadius="md" w="35%" />
                </Box>
                <Box w="14px" h="14px" borderRadius="3px" bg="gray.100" />
            </Flex>
        ))}
    </VStack>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const ParticipantsModal = ({
    isOpen, onClose, participants, hasPermission,
    selectedMeetingId, reloadParticipants, meetingStatus,
    meetingDate, meetingStartTime, meetingEndTime,
}: ParticipantsModalProps) => {

    const addModal = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    // ── Add flow state ──
    const [addStep, setAddStep] = useState<1 | 2>(1);
    const [participantTab, setParticipantTab] = useState<"Employee" | "Team" | "Mixed">("Employee");
    const [search, setSearch] = useState("");
    const [employees, setEmployees] = useState<Participant[]>([]);
    const [teamLeads, setTeamLeads] = useState<Participant[]>([]);
    const [participantsLoading, setParticipantsLoading] = useState(false);
    const [selectedParticipants, setSelectedParticipants] = useState<{ id: number; role: string }[]>([]);

    // ── Availability state (step 2) ──
    const [availabilityLoading, setAvailabilityLoading] = useState(false);
    const [availableUsers, setAvailableUsers] = useState<AvailabilityParticipant[]>([]);
    const [conflictUsers, setConflictUsers] = useState<AvailabilityParticipant[]>([]);
    const [selectedAvailable, setSelectedAvailable] = useState<number[]>([]);
    const [selectedConflict, setSelectedConflict] = useState<number[]>([]);
    const [alertConfig, setAlertConfig] = useState<{
        type: "WITHOUT_CONFLICT" | "ANYWAY";
        description: string;
        colorScheme: string;
    } | null>(null);
    const [addLoading, setAddLoading] = useState(false);

    // ── Remove confirm ──
    const [removeConfirm, setRemoveConfirm] = useState<{ participantId: number | null; isOpen: boolean }>({
        participantId: null, isOpen: false,
    });

    // ── Reset add modal ──
    const resetAddModal = useCallback(() => {
        setAddStep(1);
        setSearch("");
        setParticipantTab("Employee");
        setEmployees([]);
        setTeamLeads([]);
        setSelectedParticipants([]);
        setAvailableUsers([]);
        setConflictUsers([]);
        setSelectedAvailable([]);
        setSelectedConflict([]);
        setAlertConfig(null);
    }, []);

    // ── Load participants list ──
    const loadParticipants = useCallback(async (type: "Employee" | "Team" | "Mixed", searchTerm = "") => {
        setParticipantsLoading(true);
        const params = new URLSearchParams();
        params.append("participantType", type);
        if (searchTerm) params.append("search", searchTerm);

        const response = await fetchApi(`Meetings/participantList?${params.toString()}`, "GET");
        if (!response) { setParticipantsLoading(false); return; }

        // Filter out already-added participants
        const filterExisting = (list: Participant[]) =>
            list.filter((emp) => !participants.some((p) => p.id === emp.id));

        if (type === "Employee") {
            setEmployees(filterExisting(response));
            setTeamLeads([]);
        } else if (type === "Team") {
            setTeamLeads(filterExisting(Array.isArray(response) ? response : (response.teamLeads ?? [])));
            setEmployees([]);
        } else {
            setEmployees(filterExisting(Array.isArray(response) ? response : (response.employees ?? [])));
            setTeamLeads(filterExisting(Array.isArray(response) ? [] : (response.teamLeads ?? [])));
        }
        setParticipantsLoading(false);
    }, [fetchApi, participants]);

    // Debounced search / tab change
    useEffect(() => {
        if (!addModal.isOpen || addStep !== 1) return;
        const delay = setTimeout(() => loadParticipants(participantTab, search), search ? 400 : 0);
        return () => clearTimeout(delay);
    }, [participantTab, search, addModal.isOpen, addStep]);

    const listData = useMemo(() => {
        if (participantTab === "Employee") return employees;
        if (participantTab === "Team") return teamLeads;
        return [...employees, ...teamLeads];
    }, [participantTab, employees, teamLeads]);

    const isAllSelected = useMemo(() =>
        listData.length > 0 && listData.every((item) =>
            selectedParticipants.some((p) => p.id === item.id && p.role === item.role)
        ), [listData, selectedParticipants]);

    const isSelected = useCallback((item: Participant) =>
        selectedParticipants.some((p) => p.id === item.id && p.role === item.role),
        [selectedParticipants]);

    const toggleSelect = useCallback((item: Participant) => {
        setSelectedParticipants((prev) => {
            const exists = prev.some((p) => p.id === item.id && p.role === item.role);
            return exists
                ? prev.filter((p) => !(p.id === item.id && p.role === item.role))
                : [...prev, { id: item.id, role: item.role }];
        });
    }, []);

    const handleSelectAll = useCallback((checked: boolean) => {
        if (checked) {
            const next = listData.map((item) => ({ id: item.id, role: item.role }));
            setSelectedParticipants((prev) => {
                const combined = [...prev, ...next];
                return combined.filter((v, i, arr) =>
                    arr.findIndex((x) => x.id === v.id && x.role === v.role) === i
                );
            });
        } else {
            setSelectedParticipants((prev) =>
                prev.filter((p) => !listData.some((item) => item.id === p.id && item.role === p.role))
            );
        }
    }, [listData]);

    // ── Step 1 → Step 2: check availability ──
    const handleCheckAvailability = async () => {
        if (selectedParticipants.length === 0) {
            addToast({ message: "Please select at least one participant", status: "error" });
            return;
        }
        setAddStep(2);
        setAvailabilityLoading(true);

        const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const payload = {
            participants: selectedParticipants,
            meetingDate: meetingDate,
            startTime: meetingStartTime ? `${meetingStartTime}:00` : undefined,
            endTime: meetingEndTime ? `${meetingEndTime}:00` : undefined,
            timeZoneId,
        };

        const response = await fetchApi("Meetings/checkAvailability", "POST", payload);
        if (response) {
            setAvailableUsers(response.available ?? []);
            setConflictUsers(response.conflict ?? []);
            setSelectedAvailable((response.available ?? []).map((u: AvailabilityParticipant) => u.id));
            setSelectedConflict((response.conflict ?? []).map((u: AvailabilityParticipant) => u.id));
        }
        setAvailabilityLoading(false);
    };

    // ── Final submit ──
    const submitAdd = async (participantIds: number[]) => {
        if (!participantIds.length) {
            addToast({ message: "No participants to add", status: "warning" });
            return;
        }
        setAddLoading(true);
        try {
            const response = await fetchApi("Meetings/update-participants", "POST", {
                meeting_Id: selectedMeetingId,
                selectedParticipants: participantIds,
            });
            if (response) {
                addToast({ message: "Participants added successfully", status: "success" });
                reloadParticipants(selectedMeetingId, meetingStatus);
                resetAddModal();
                addModal.onClose();
            }
        } finally {
            setAddLoading(false);
            setAlertConfig(null);
        }
    };

    const handleConfirmAdd = () => {
        if (!alertConfig) return;
        const ids =
            alertConfig.type === "WITHOUT_CONFLICT"
                ? selectedAvailable
                : [...selectedAvailable, ...selectedConflict];
        submitAdd(ids);
    };

    // ── Remove participant ──
    const confirmRemoveParticipant = async () => {
        if (!removeConfirm.participantId) return;
        const response = await fetchApi("Meetings/remove-participant", "PUT", {
            meeting_Id: selectedMeetingId,
            participant_Id: removeConfirm.participantId,
        });
        if (response) {
            addToast({ message: "Participant removed successfully", status: "success" });
            reloadParticipants(selectedMeetingId, meetingStatus);
        }
        setRemoveConfirm({ participantId: null, isOpen: false });
    };

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <>
            {/* ── Main participants table modal ── */}
            <Modal
                isOpen={isOpen}
                onClose={() => { resetAddModal(); onClose(); }}
                size="5xl" isCentered
            >
                <ModalOverlay />
                <ModalContent h="70vh">
                    <ModalHeader>
                        <Flex direction="column" align="center" gap={2}>
                            <Text className="font-poppins text_semibold text_xl" textAlign="center">
                                Meeting Participants
                            </Text>
                            <Text className="font-poppins text_md text_medium" color="gray.500">
                                Total Participants: {participants.length}
                            </Text>
                        </Flex>
                        {hasPermission("MeetingsManagement", "Add_Participant") && meetingStatus !== "Completed" && (
                            <Button
                                size="sm" colorScheme="green"
                                onClick={() => { resetAddModal(); loadParticipants("Employee", ""); addModal.onOpen(); }}
                            >
                                Add Participant
                            </Button>
                        )}
                    </ModalHeader>
                    <ModalCloseButton />
                    <Divider />

                    <ModalBody overflowY="auto" p={4}>
                        <TableContainer>
                            <Table size="sm">
                                <Thead>
                                    <Tr>
                                        <Th>Participant</Th>
                                        <Th>TL</Th>
                                        <Th>Manager</Th>
                                        <Th>Company</Th>
                                        <Th>Branch</Th>
                                        <Th>Department</Th>
                                        <Th>Acceptance</Th>
                                        <Th>Status</Th>
                                        <Th>Time</Th>
                                        {hasPermission("MeetingsManagement", "Remove_Participant") && meetingStatus !== "Completed" && (
                                            <Th>Action</Th>
                                        )}
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {participants.map((p) => (
                                        <Tr key={p.id}>
                                            <Td>
                                                <Flex align="center" gap={3}>
                                                    <Avatar size="sm" name={p.name} src={p.avatarUrl || undefined} />
                                                    <Box>
                                                        <Text className="font-poppins text_md text_medium font_dark">{p.name}</Text>
                                                        <Text className="font-poppins text_sm text_medium" color="gray.600">{p.role}</Text>
                                                    </Box>
                                                </Flex>
                                            </Td>
                                            <Td><Badge>{p.tl_Name}</Badge></Td>
                                            <Td><Badge>{p.manager_Name}</Badge></Td>
                                            <Td><Badge>{p.company_Name}</Badge></Td>
                                            <Td><Badge>{p.branch_Name}</Badge></Td>
                                            <Td><Badge>{p.department_Name}</Badge></Td>
                                            <Td>
                                                {p.acceptance_Status === "Accepted" && <Badge colorScheme="green">Accepted</Badge>}
                                                {p.acceptance_Status === "Declined" && (
                                                    <Tooltip label={p.decline_Reason || "No reason provided"} hasArrow placement="top" bg="gray.700" color="white" fontSize="sm" borderRadius="md">
                                                        <Badge colorScheme="red" cursor="pointer">Declined</Badge>
                                                    </Tooltip>
                                                )}
                                                {(!p.acceptance_Status || p.acceptance_Status === "Pending") && (
                                                    <Badge colorScheme={meetingStatus === "Completed" ? "red" : "gray"}>
                                                        {meetingStatus === "Completed" ? "No Action Taken" : "Pending"}
                                                    </Badge>
                                                )}
                                            </Td>
                                            <Td>
                                                {meetingStatus === "Completed" && (!p.acceptance_Status || p.acceptance_Status === "Pending") ? (
                                                    <Badge colorScheme="red">No Action Taken</Badge>
                                                ) : (
                                                    <Badge
                                                        colorScheme={
                                                            p.attendance_Status === "Joined" ? "green"
                                                                : p.attendance_Status === "Declined" ? "red"
                                                                    : p.attendance_Status === "Absent" ? "orange"
                                                                        : "gray"
                                                        }
                                                    >
                                                        {p.attendance_Status ?? "Pending"}
                                                    </Badge>
                                                )}
                                            </Td>
                                            <Td>
                                                {p.joined_At && <Text fontSize="sm" color="green.600">{showDateTime(p.joined_At)}</Text>}
                                                {p.declined_At && <Text fontSize="sm" color="red.500">{showDateTime(p.declined_At)}</Text>}
                                                {!p.joined_At && !p.declined_At && <Text fontSize="sm" color="gray.500">—</Text>}
                                            </Td>
                                            {hasPermission("MeetingsManagement", "Remove_Participant") && meetingStatus !== "Completed" && !p.is_Creator && (
                                                <Td>
                                                    <IconButton
                                                        aria-label="Remove Participant"
                                                        icon={<DeleteIcon />}
                                                        size="sm" colorScheme="red" variant="ghost"
                                                        onClick={() => setRemoveConfirm({ participantId: p.id, isOpen: true })}
                                                    />
                                                </Td>
                                            )}
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* ── Add Participant modal (2-step) ── */}
            <Modal
                isOpen={addModal.isOpen}
                onClose={() => { resetAddModal(); addModal.onClose(); }}
                size="xl" isCentered
            >
                <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(2px)" />
                <ModalContent borderRadius="14px" overflow="hidden">
                    <ModalHeader pb={0} pt={5}>
                        <Text textAlign="center" fontSize="md" fontWeight="600" color="gray.800">
                            Add Participants
                        </Text>
                        <ModalCloseButton top={4} right={4} />
                        <AddStepIndicator step={addStep} />
                    </ModalHeader>

                    <Divider mt={4} />

                    <ModalBody overflowY="auto" px={6} py={5}>

                        {/* ── STEP 1: Search & select ── */}
                        {addStep === 1 && (
                            <VStack spacing={3} align="stretch">
                                <Tabs
                                    index={["Employee", "Team", "Mixed"].indexOf(participantTab)}
                                    onChange={(i) => {
                                        const types = ["Employee", "Team", "Mixed"] as const;
                                        setParticipantTab(types[i]);
                                        setSearch("");
                                    }}
                                    colorScheme="green" size="sm" variant="line"
                                >
                                    <TabList>
                                        <Tab fontWeight="500" fontSize="sm">Employee</Tab>
                                        <Tab fontWeight="500" fontSize="sm">Team Lead</Tab>
                                        <Tab fontWeight="500" fontSize="sm">Mixed</Tab>
                                    </TabList>
                                </Tabs>

                                <InputGroup size="sm">
                                    <InputLeftElement pointerEvents="none">
                                        <SearchIcon color="gray.400" />
                                    </InputLeftElement>
                                    <Input
                                        placeholder="Search by name..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        borderRadius="md"
                                    />
                                </InputGroup>

                                <Flex align="center" justify="space-between">
                                    <Text fontSize="xs" color="gray.500">
                                        {selectedParticipants.length > 0
                                            ? `${selectedParticipants.length} selected`
                                            : "No participants selected yet"}
                                    </Text>
                                    <Checkbox
                                        isChecked={isAllSelected}
                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                        colorScheme="green" size="sm"
                                    >
                                        <Text fontSize="xs" color="gray.500">Select all</Text>
                                    </Checkbox>
                                </Flex>

                                <Box
                                    border="0.5px solid" borderColor="gray.200"
                                    borderRadius="lg" overflow="hidden" maxH="340px" overflowY="auto"
                                >
                                    {participantsLoading ? (
                                        <SkeletonRows />
                                    ) : listData.length === 0 ? (
                                        <Flex align="center" justify="center" py={8}>
                                            <Text fontSize="sm" color="gray.400">No results found</Text>
                                        </Flex>
                                    ) : (
                                        listData.map((item, idx) => (
                                            <ParticipantRow
                                                key={`${item.id}-${item.role}-${idx}`}
                                                item={item}
                                                checked={isSelected(item)}
                                                onToggle={() => toggleSelect(item)}
                                            />
                                        ))
                                    )}
                                </Box>
                            </VStack>
                        )}

                        {/* ── STEP 2: Availability ── */}
                        {addStep === 2 && (
                            <Box>
                                {availabilityLoading ? (
                                    <Flex align="center" justify="center" py={10} gap={3} direction="column">
                                        <Spinner color="green.600" size="md" />
                                        <Text fontSize="sm" color="gray.500">Checking availability...</Text>
                                    </Flex>
                                ) : (
                                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                        {/* Available */}
                                        <GridItem>
                                            <Flex align="center" gap={2} mb={2}>
                                                <Box w="8px" h="8px" borderRadius="full" bg="green.500" />
                                                <Text fontSize="sm" fontWeight="600" color="gray.700">
                                                    {availableUsers.length} Available
                                                </Text>
                                            </Flex>
                                            <Box
                                                border="0.5px solid" borderColor="gray.200"
                                                borderRadius="lg" overflow="hidden" maxH="340px" overflowY="auto"
                                            >
                                                {availableUsers.length === 0 ? (
                                                    <Flex py={6} justify="center">
                                                        <Text fontSize="sm" color="gray.400">No available participants</Text>
                                                    </Flex>
                                                ) : availableUsers.map((u) => (
                                                    <Flex
                                                        key={u.id} align="center" gap={3} px={3} py="9px"
                                                        borderBottom="0.5px solid" borderColor="gray.100"
                                                        _last={{ borderBottom: "none" }}
                                                        bg={selectedAvailable.includes(u.id) ? "green.50" : "white"}
                                                        cursor="pointer"
                                                        onClick={() => setSelectedAvailable((prev) =>
                                                            prev.includes(u.id) ? prev.filter((id) => id !== u.id) : [...prev, u.id]
                                                        )}
                                                    >
                                                        <Avatar size="sm" name={u.name} bg="green.100" color="green.700" />
                                                        <Box flex={1}>
                                                            <Text fontSize="sm" fontWeight="500">{u.name}</Text>
                                                            <Text fontSize="xs" color="gray.400">{u.role}</Text>
                                                        </Box>
                                                        <Checkbox
                                                            isChecked={selectedAvailable.includes(u.id)}
                                                            pointerEvents="none"
                                                            colorScheme="green"
                                                        />
                                                    </Flex>
                                                ))}
                                            </Box>
                                        </GridItem>

                                        {/* Conflict */}
                                        <GridItem>
                                            <Flex align="center" gap={2} mb={2}>
                                                <Box w="8px" h="8px" borderRadius="full" bg="red.400" />
                                                <Text fontSize="sm" fontWeight="600" color="gray.700">
                                                    {conflictUsers.length} Conflict
                                                </Text>
                                            </Flex>
                                            <Box
                                                border="0.5px solid" borderColor="gray.200"
                                                borderRadius="lg" overflow="hidden" maxH="340px" overflowY="auto"
                                            >
                                                {conflictUsers.length === 0 ? (
                                                    <Flex py={6} justify="center">
                                                        <Text fontSize="sm" color="gray.400">No conflicts</Text>
                                                    </Flex>
                                                ) : conflictUsers.map((u) => (
                                                    <Flex
                                                        key={u.id} align="center" gap={3} px={3} py="9px"
                                                        borderBottom="0.5px solid" borderColor="gray.100"
                                                        _last={{ borderBottom: "none" }}
                                                        bg={selectedConflict.includes(u.id) ? "red.50" : "white"}
                                                        cursor="pointer"
                                                        onClick={() => setSelectedConflict((prev) =>
                                                            prev.includes(u.id) ? prev.filter((id) => id !== u.id) : [...prev, u.id]
                                                        )}
                                                    >
                                                        <Avatar size="sm" name={u.name} bg="red.100" color="red.600" />
                                                        <Box flex={1}>
                                                            <Text fontSize="sm" fontWeight="500">{u.name}</Text>
                                                            <Text fontSize="xs" color="gray.400">{u.role}</Text>
                                                        </Box>
                                                        <Checkbox
                                                            isChecked={selectedConflict.includes(u.id)}
                                                            pointerEvents="none"
                                                            colorScheme="red"
                                                        />
                                                    </Flex>
                                                ))}
                                            </Box>
                                        </GridItem>
                                    </Grid>
                                )}
                            </Box>
                        )}
                    </ModalBody>

                    <Divider />
                    <ModalFooter justifyContent="space-between" px={6} py={4}>
                        {/* Back button */}
                        <Box>
                            {addStep === 2 && (
                                <Button
                                    variant="ghost" size="sm" leftIcon={<ArrowBackIcon />}
                                    color="gray.600"
                                    onClick={() => setAddStep(1)}
                                >
                                    Back
                                </Button>
                            )}
                        </Box>

                        {/* Right-side actions */}
                        <HStack spacing={2}>
                            {addStep === 1 && (
                                <Button
                                    bg="#006838" color="white" size="sm"
                                    _hover={{ bg: "#005529" }}
                                    rightIcon={<ArrowForwardIcon />}
                                    onClick={handleCheckAvailability}
                                >
                                    Check availability
                                </Button>
                            )}

                            {addStep === 2 && !availabilityLoading && (
                                <>
                                    {conflictUsers.length === 0 ? (
                                        <Button
                                            bg="#006838" color="white" size="sm"
                                            _hover={{ bg: "#005529" }}
                                            onClick={() =>
                                                setAlertConfig({
                                                    type: "ANYWAY",
                                                    description: "All participants are available. Do you want to add them to this meeting?",
                                                    colorScheme: "green",
                                                })
                                            }
                                        >
                                            Add participants
                                        </Button>
                                    ) : (
                                        <>
                                            <Button
                                                variant="outline" size="sm" colorScheme="green"
                                                onClick={() => {
                                                    if (availableUsers.length === 0) {
                                                        addToast({ message: "No available participants to add", status: "warning" });
                                                        return;
                                                    }
                                                    const excluded =
                                                        availableUsers.filter((u) => !selectedAvailable.includes(u.id)).length +
                                                        conflictUsers.length;
                                                    setAlertConfig({
                                                        type: "WITHOUT_CONFLICT",
                                                        description: `${excluded} participant(s) with conflicts will be excluded. Continue?`,
                                                        colorScheme: "green",
                                                    });
                                                }}
                                            >
                                                Skip conflicts
                                            </Button>
                                            <Button
                                                colorScheme="red" size="sm"
                                                onClick={() => {
                                                    const excluded = conflictUsers.filter((u) => !selectedConflict.includes(u.id)).length;
                                                    setAlertConfig({
                                                        type: "ANYWAY",
                                                        description:
                                                            excluded > 0
                                                                ? `${selectedConflict.length} conflict participant(s) included, ${excluded} excluded. Continue?`
                                                                : `${conflictUsers.length} participant(s) have conflicts but will be included. Continue anyway?`,
                                                        colorScheme: "red",
                                                    });
                                                }}
                                            >
                                                Include all
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}
                        </HStack>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* ── Confirm add alert ── */}
            <AlertCard
                isOpen={!!alertConfig}
                isLoading={addLoading}
                onClose={() => { if (!addLoading) setAlertConfig(null); }}
                onConfirm={handleConfirmAdd}
                description={alertConfig?.description || ""}
                colorScheme={alertConfig?.colorScheme || "green"}
            />

            {/* ── Confirm remove alert ── */}
            <AlertCard
                isOpen={removeConfirm.isOpen}
                onClose={() => setRemoveConfirm({ participantId: null, isOpen: false })}
                onConfirm={confirmRemoveParticipant}
                description="Are you sure you want to remove this participant from the meeting?"
                colorScheme="red"
            />
        </>
    );
};

export default ParticipantsModal;